import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './auth-token.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AuthTokenDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const authTokenEntity = useAppSelector(state => state.authToken.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="authTokenDetailsHeading">
          <Translate contentKey="comexApp.authToken.detail.title">AuthToken</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{authTokenEntity.id}</dd>
          <dt>
            <span id="accessToken">
              <Translate contentKey="comexApp.authToken.accessToken">Access Token</Translate>
            </span>
          </dt>
          <dd>{authTokenEntity.accessToken}</dd>
          <dt>
            <span id="expiresIn">
              <Translate contentKey="comexApp.authToken.expiresIn">Expires In</Translate>
            </span>
          </dt>
          <dd>{authTokenEntity.expiresIn}</dd>
        </dl>
        <Button tag={Link} to="/auth-token" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/auth-token/${authTokenEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AuthTokenDetail;
